/**
 * Composable pour le formatage des dates du calendrier
 * Limite: 40 lignes max
 */
import { formatDateForStorage, formatDateForDisplay } from '../../utils/dateFormatters.js'

export function useCalendarFormatting() {
  return {
    formatDateForStorage,
    formatDateForDisplay
  }
}
